function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 6)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.605 0c-1.956 6.618.068 11.128 6.072 13.53 9.005 3.604 14.282.585 19.39 3.156C31.473 18.4 33.85 21.858 35.2 27.06",
  stroke: "#000",
  strokeWidth: "2",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  cx: "1.956",
  cy: "4.571",
  r: "1.956"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  cx: "11.733",
  cy: "14.349",
  r: "1.956"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  cx: "27.378",
  cy: "16.305",
  r: "1.956"
}))));